import { ReactNode, useEffect, useState } from 'react';

import { TextFieldProps } from '@mui/material';

import { StyleTextField } from '../style';

import { measureText } from 'src/helpers/utils';
import theme from 'src/theme';

export type BlankTextFieldProps = TextFieldProps & {
  isError?: boolean;
  isCorrect?: boolean;
  isLoading?: boolean;
  value: string;
  renderCorrectAnswer: (boxWidth: number) => ReactNode;
  onChange: React.ChangeEventHandler;
};

const DEFAULT_WIDTH = 100;

const BlankTextField = ({ renderCorrectAnswer, isLoading, ...props }: BlankTextFieldProps) => {
  const { value } = props;
  const [width, setWidth] = useState(DEFAULT_WIDTH);

  useEffect(() => {
    if (!value) {
      setWidth(DEFAULT_WIDTH);
    } else {
      const textWidth = measureText(props.value, `24px ${theme.typography.fontFamily}`);
      setWidth(textWidth < DEFAULT_WIDTH ? DEFAULT_WIDTH : textWidth);
    }
  }, [value]);

  return (
    <>
      <StyleTextField width={width} {...props} />
      {renderCorrectAnswer(width)}
    </>
  );
};

export default BlankTextField;
